module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reload":"Reload"},"fr":{"reload":"Recharger"}}')
  delete Component.options._Ctor
}
